// extracted by mini-css-extract-plugin
export var Clickable = "index-module--Clickable--e6ea9";